
import { FeedbackKeys } from '@/i18n/types';

export const feedback: Record<FeedbackKeys, string> = {
  feedback: 'Feedback',
  submitFeedback: 'Submit Feedback',
  feedbackTitle: 'Feedback Title',
  feedbackDescription: 'Feedback Description',
  feedbackType: 'Feedback Type',
  suggestion: 'Suggestion',
  bugReport: 'Bug Report',
  question: 'Question',
  feedbackSubmitted: 'Feedback Submitted',
  thanksForFeedback: 'Thanks for your feedback. It has been sent to info@planwisenow.io',
  improvement: 'Improvement',
  comment: 'Comment',
  error: 'Error',
  feedbackHistory: 'Your Feedback History',
  feedbackIntro: 'Share your suggestions, report bugs, or ask questions to help us improve.',
  feedbackTitlePlaceholder: 'Write a brief title',
  feedbackDescriptionPlaceholder: 'Describe your suggestion or comment in detail',
  selectType: 'Select a type',
  submitting: 'Submitting...',
  mustBeLoggedIn: 'You must be logged in to submit feedback.',
  loginToSubmitFeedback: 'You must be logged in to submit feedback.',
  loginToViewHistory: 'Log in to view your feedback history',
  noFeedbackYet: 'You haven\'t submitted any feedback yet.',
  errorLoadingFeedback: 'Error loading feedback. Please try again.',
  tryAgain: 'Please try again.',
  loading: 'Loading...',
  pending: 'Pending',
  reviewed: 'Reviewed',
  implemented: 'Implemented',
  allFeedbackSentTo: 'All feedback is sent to info@planwisenow.io for review.',
  couldNotSubmitFeedback: 'Could not submit your feedback. Please try again.',
  titleMinLength: 'Title must be at least 5 characters',
  descriptionMinLength: 'Description must be at least 10 characters',
};
